<template>
  <v-list-item>
    <v-list-item-content>
      <v-list-item-title class="text-wrap">Изменить звук гудка</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-dialog v-model="ringSound" persistent max-width="400">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" class="text-none" rounded>
            Выбрать
          </v-btn>
        </template>
        <v-card>
          <v-card-title>Загрузите звук гудка</v-card-title>
          <v-file-input
            ref="doorRingFile"
            accept=".wav"
            label="Выберите файл"
            class="pa-5"
            :rules="[
                      value => !!value || 'Обязательное поле',
                      value => !value || value.name.split('.').pop() === 'wav' || 'Аудиофайл должен быть в формате WAV',
                      value => !value || value.size < 200000 || 'Размер не должен превышать больше 200Кб',
                    ]"
            @change="preRingSound"
          ></v-file-input>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              class="text-none"
              @click="ringSound = false"
            >
              Отменить
            </v-btn>
            <v-btn
              color="success"
              @click="changeSoundBeep"
              :disabled="!soundBeep.valid"
            >
              Загрузить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogResultUpload" max-width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2">
            Результат
          </v-card-title>
          <v-card-text>
            <v-col v-if="issetRightDoorphones()">
              <h3>Успешно загружен на домофоны:</h3>
              <ul>
                <li v-for="(doorphone) in soundBeep.result.right_doorphones" :key="doorphone.id">
                  {{ doorphone.id }} - {{ doorphone.address }}, п.{{ doorphone.entrance }}
                </li>
              </ul>
            </v-col>
            <v-col v-if="issetFailDoorphones()">
              <h3>Не удалось загрузить на домофоны:</h3>
              <ul>
                <li v-for="(doorphone) in soundBeep.result.fail_doorphones" :key="doorphone.id">
                  {{ doorphone.id }} - {{ doorphone.address }}, п.{{ doorphone.entrance }}
                </li>
              </ul>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialogResultUpload = false"
            >
              Закрыть
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'RingSound',
  props: ['doorphones'],
  data () {
    return {
      ringSound: false,
      dialogResultUpload: false,
      soundBeep: {
        file: '',
        valid: false,
        result: {},
      },
    };
  },
  methods: {
    ...mapActions({
      uploadMassRingsound: 'Doorphone/uploadMassRingsound',
    }),
    preRingSound (e) {
      this.soundBeep.file = e;
      this.soundBeep.valid = !this.$refs.doorRingFile.valid;
    },
    changeSoundBeep () {
      this.$refs.doorRingFile.validate(true);
      this.$nextTick(() => {
        if (this.soundBeep.valid) {
          const formData = new FormData();
          formData.append('sound', this.soundBeep.file);

          this.doorphones.forEach((doorphone, index) => {
            formData.append(`doorphones[${index}]`, doorphone.id);
          });

          this.uploadMassRingsound(formData)
            .then((res) => {
              this.soundBeep.file = '';
              this.ringSound = false;
              this.soundBeep.result = res;
              this.dialogResultUpload = true;
            })
            .catch(e => console.error(e));
        }
      });
    },
    issetRightDoorphones () {
      return this.soundBeep.result.right_doorphones && this.soundBeep.result.right_doorphones.length > 0;
    },
    issetFailDoorphones () {
      return this.soundBeep.result.fail_doorphones && this.soundBeep.result.fail_doorphones.length > 0;
    },
  },
};
</script>

<style scoped>

</style>
